
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#e6e6e6"}}),_c('line',{attrs:{"x1":"75.66","y1":"115.24","x2":"75.66","y2":"127.26","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"67.51","y1":"112.05","x2":"57.44","y2":"121.32","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"82.59","y1":"112.05","x2":"92.65","y2":"121.32","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"98.47","y1":"44.83","x2":"110.47","y2":"42.16","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"92.67","y1":"39.87","x2":"96.89","y2":"26.85","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"50.3","y1":"44.83","x2":"38.3","y2":"42.16","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"56.1","y1":"39.87","x2":"51.88","y2":"26.85","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('polyline',{attrs:{"points":"80.15 43.49 87.04 59.24 116.61 62.16 94.41 81.91 100.77 110.94 75.12 95.93 49.48 110.94 55.83 81.91 33.63 62.16 63.2 59.24 75.12 32.02","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    